export class GoToOverviewTabEvent {}
